LabelsView = require 'views/label/labels-view'
PopOver = require 'views/lib/pop-over'
View = require 'view'
track = require 'debug/track'

module.exports = class CardLabelSelectView extends View
  viewTitleKey: 'labels'

  el: ->
    @labelsView = @subview LabelsView, @model,
      board: @model.getBoard()
      selectLabel: @toggleLabel.bind(@)
      renderOn: [
        { source: @model.labelList, events: 'add remove reset change' }
        { source: @model, events: 'change:labels, change:idLabels' }
      ]
      popOverMethod: 'pushView'
      searchInit: @options.searchInit

    @labelsView.render().el

  toggleLabel: (idLabel) ->
    track(@model.typeName, "Card Labels Menu", "Change Label")
    @model.toggleLabel(@modelCache.get('Label', idLabel))
    if @options.hideOnSelect
      PopOver.popView()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/label/card-label-select-view.coffee